/**
 * Custom Script: Prevent purchasing Gift
 */
(function() {
    // ==== Toast Notification ====
    function showToast(message, duration = 3000) {
        if (!document.getElementById('tl-toast-style')) {
            const style = document.createElement('style');
            style.id = 'tl-toast-style';
            style.textContent = `
                .tl-toast-container {
                    position: fixed;
                    top: 20px;
                    left: 50%;
                    transform: translateX(-50%);
                    z-index: 999999;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 10px;
                    pointer-events: none;
                }
                .tl-toast {
                    background: #333333;
                    color: #ffffff;
                    padding: 12px 20px;
                    border-radius: 8px;
                    font-size: 14px;
                    font-family: inherit;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    max-width: 90vw;
                    opacity: 0;
                    transform: translateY(-20px);
                    transition: opacity 0.3s ease, transform 0.3s ease;
                }
                .tl-toast.tl-toast-show { opacity: 1; transform: translateY(0); }
                .tl-toast.tl-toast-hide { opacity: 0; transform: translateY(-20px); }
                .tl-toast-icon { flex-shrink: 0; width: 18px; height: 18px; }
                .tl-toast-message { line-height: 1.4; }
            `;
            document.head.appendChild(style);
        }
        let container = document.querySelector('.tl-toast-container');
        if (!container) {
            container = document.createElement('div');
            container.className = 'tl-toast-container';
            document.body.appendChild(container);
        }
        const toast = document.createElement('div');
        toast.className = 'tl-toast';
        toast.innerHTML = `
            <svg class="tl-toast-icon" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#FFB020" stroke-width="2"/>
                <path d="M12 8V13" stroke="#FFB020" stroke-width="2" stroke-linecap="round"/>
                <circle cx="12" cy="16" r="1" fill="#FFB020"/>
            </svg>
            <span class="tl-toast-message">${message}</span>
        `;
        container.appendChild(toast);
        requestAnimationFrame(() => toast.classList.add('tl-toast-show'));
        setTimeout(() => {
            toast.classList.remove('tl-toast-show');
            toast.classList.add('tl-toast-hide');
            setTimeout(() => toast.remove(), 300);
        }, duration);
    }

    // ==== Kiểm tra xem variant có là gift trong giỏ hàng không ====
    // Lấy từ Cart API để đảm bảo chính xác 100%
    async function isGiftInCart(variantId) {
        if (!variantId) return false;
        try {
            const rootUrl = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
            const res = await fetch(rootUrl + 'cart.js');
            const cart = await res.json();

            for (const item of cart.items) {
                // Shopify: item.id = variant_id, item.variant_id = variant_id
                const sameVariant = String(item.id) === String(variantId) 
                                 || String(item.variant_id) === String(variantId);

                if (sameVariant) {
                    const props = item.properties || {};

                    // 1. Kiểm tra Free Gift app: có property _tl_salepify_rule hay tương tự
                    const isFreeGiftProp = Object.keys(props).some(key => 
                        key.startsWith('_tl') || key === '_is_free_gift'
                    );

                    // 2. Kiểm tra Progress Bar: có property _salepify-cart-goal
                    const isCartGoalProp = Object.keys(props).some(key => 
                        key.includes('salepify') || key.includes('cart-goal')
                    );

                    // 3. Giá = 0 (Luôn là dấu hiệu chắc chắn nhất)
                    const isPriceFree = item.price === 0;

                    if (isFreeGiftProp || isCartGoalProp || isPriceFree) {
                        return true;
                    }
                }
            }
            return false;
        } catch(e) {
            console.warn('[Prevent Gift] Cart check error:', e);
            return false;
        }
    }

    // ==== Chặn Form Submit (Product Page - Add to Cart button) ====
    document.addEventListener('submit', async function(e) {
        if (!e.target || !e.target.action || !e.target.action.includes('/cart/add')) return;

        const formData = new FormData(e.target);
        let variantId = formData.get('id');

        // Một số theme dùng items[0][id]
        if (!variantId) {
            for (let [key, val] of formData.entries()) {
                if (key.includes('[id]') || key === 'id') { variantId = val; break; }
            }
        }

        if (variantId) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const isGift = await isGiftInCart(variantId);
            if (isGift) {
                showToast("This product is already in your cart as a free gift. You cannot purchase it.");
                return;
            }

            // Nếu không phải gift, submit lại form thật
            e.target.submit();
        }
    }, true);

    // ==== Chức năng vô hiệu hóa nút Add to Cart trên Product Page ====
    async function disableAddToCartIfGift() {
        const urlParams = new URLSearchParams(window.location.search);
        let currentVariantId = urlParams.get('variant');
        if (!currentVariantId) {
            const variantInput = document.querySelector('input[name="id"]');
            if (variantInput) currentVariantId = variantInput.value;
        }
        if (!currentVariantId) return;

        const isGift = await isGiftInCart(currentVariantId);
        const buttons = document.querySelectorAll(
            'button[name="add"], input[name="add"], button[type="submit"].product-form__submit'
        );

        if (isGift) {
            buttons.forEach(btn => {
                btn.disabled = true;
                if (!btn.dataset.originalText) btn.dataset.originalText = btn.innerHTML;
                btn.innerHTML = "Already in cart";
            });
        } else {
            buttons.forEach(btn => {
                btn.disabled = false;
                if (btn.dataset.originalText) {
                    btn.innerHTML = btn.dataset.originalText;
                    delete btn.dataset.originalText;
                }
            });
        }
    }

    // ==== Lắng nghe sự kiện ====
    window.addEventListener('load', () => setTimeout(disableAddToCartIfGift, 1000));

    // Đổi variant trên Product Page
    document.addEventListener('change', () => setTimeout(disableAddToCartIfGift, 300));

    // Cart update từ Free Gift app
    ['TLFREEGIFT:update', 'TLFREEGIFT:change', 'TLCARTGOAL:add', 'TLCARTGOAL:update'].forEach(evt => {
        window.addEventListener(evt, () => setTimeout(disableAddToCartIfGift, 500));
    });
})();